import {implementCallback, generateCallback} from '../util/appCallback';
import util from '../util/common';

// 移除右上角按钮
export function offMenu(option = {}) {
    let menu = option.menu;
    if (menu === 3) {
        if (this['navRightButtonInfo']) {
            setTimeout(() => {
                this['navRightButtonInfo']({
                    type: 3,
                    text: ' ',
                    jsmethod: 'Mama.noop'
                });
                this['navRightButtonInfo1']({
                    type: 3,
                    text: ' ',
                    jsmethod: 'Mama.noop'
                });
                implementCallback({code: 0}, option);
            }, 100);
        }
    } else {
        menu = menu === 1 ? 1 : '';
        if (this[`navRightButtonInfo${menu}`]) {
            setTimeout(() => {
                this[`navRightButtonInfo${menu}`]({
                    type: 3,
                    text: ' ',
                    jsmethod: 'Mama.noop'
                });
                implementCallback({code: 0}, option);
            }, 100);
        }
    }
}

// 右上角按钮配置
const menuItemCallback = {};
export function menuItem(option = {}) {
    let menu = option.menu;
    option.btnText = option.btnText || '';
    option.btnIcon = option.btnIcon ? util.formatURL(option.btnIcon) : '';
    if (option.btnText === '' && option.btnIcon === '') {
        throw new Error('请配置菜单文字或图标！');
    }
    menu = menu === 1 ? 1 : '';
    if (option.type === 1 && option.targetNativeName === '') {
        throw new Error('原生模块名不能为空！');
    }
    if (option.type === 2 && option.url === '') {
        throw new Error('跳转链接不能为空！');
    }
    const methodName = `navRightButtonInfo${menu}`;
    if (menuItemCallback[methodName]) {
        // 主动销毁上一个回调函数
        window[menuItemCallback[methodName]] = null;
    }
    menuItemCallback[methodName] = generateCallback(option, false, false);
    this[methodName] &&
        this[methodName]({
            type: option.type,
            text: option.btnText,
            icon: option.btnIcon,
            subtype: option.targetNativeName || '',
            waplink: util.formatURL(option.url),
            jsmethod: menuItemCallback[methodName],
            ext: option.ext || {}
        });
}

/**
 * 更多菜单按钮
 * @param {string} option.listStyle.textColor 字体颜色值，HEX 格式，例如：#000000
 * @param {string} option.listStyle.textColor 背景颜色值，HEX 格式，例如：#ffffff
 */
export function moreMenu(option = {}) {
    if (!option.list || option.list.length <= 0) {
        throw new Error('列表不能为空！');
    }
    let menu = option.menu;
    menu = menu === 1 ? 1 : '';
    option.btnText = option.btnText || '';
    option.btnIcon = option.btnIcon && util.formatURL(option.btnIcon);
    if (!option.btnText && !option.btnIcon) {
        option.btnIcon = 'https://static-files.cdnmama.com/common/pt-btn-more.png';
    }
    const methodName = `navRightButtonInfo${menu}`;
    if (menuItemCallback[methodName]) {
        // 主动销毁上一个回调函数
        window[menuItemCallback[methodName]] = null;
    }
    option.list.map(item => {
        item.icon = util.formatURL(item.icon);
        return item;
    });
    menuItemCallback[methodName] = generateCallback(
        {
            success: () => {
                this.invocation({
                    action: 'moreMenu',
                    data: {
                        list: option.list,
                        textcolor: option.textColor ? option.textColor : '',
                        bgcolor: option.backgroundColor ? option.backgroundColor : ''
                    }
                });
            }
        },
        false,
        false
    );
    this[methodName] &&
        this[methodName]({
            type: 3,
            text: option.btnText,
            icon: option.btnIcon,
            subtype: '',
            waplink: '',
            jsmethod: menuItemCallback[methodName],
            ext: {}
        });
}

export default {
    offMenu,
    menuItem,
    moreMenu
};
